import Vue from 'vue'
import { createApp } from './app'
import './components/Notify'
import { createAxios } from './plugins/axios'
import { createSocket } from './plugins/socket'
import vueDebounce from 'vue-debounce'
import FileSeaver from 'file-saver'

import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

const env = require('../env.json');

const { app, router, store } = createApp();

router.onReady(() => {
  if (window.__INITIAL_STATE__) {
    // заменяет стейт на тот, что пришел с сервера
    store.replaceState(window.__INITIAL_STATE__);
  }

  store.commit('setApi', env.api)
  store.commit('setDomain', env.domain)
  store.commit('setLk', env.lk)
  store.commit('setSocket', env.socket)

  Vue.prototype.$fileSeaver = FileSeaver;
  Vue.use(vueDebounce, {
    listenTo: ['input', 'textarea'],
    defaultTime: '700ms',
  })
  Vue.prototype.$axios = createAxios(store, router)
  Vue.prototype.$client = createSocket(store)

  if(store.getters.getToken) {
    Vue.prototype.$axios.get(`auth/me`, {
      mute: true,
    }).then(res => {
      store.commit('setUser', res.data.result.user[0])
    }).finally(() => {
    })
  }
  app.$mount('#app');
});



// WEBPACK FOOTER //
// ./src/entry-client.js